import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import category from '../../../../store/modules/category';

import * as func from "../../../../utils/functions";

import {MESSAGE, EDIT_MODE} from "../../../../wpconfig"

import * as FActions from "../../../../store/modules/footer";

import InputBox from '../../../etc/InputBox'
import Treebox from '../../../etc/TreeBox'
import Item from "../../../etc/TreeBox/item";
import CategoryItem from "./item";
import PCodeItem from "../code/module/pCodeItem";
import {getParams, pushUrl} from "../../../../utils/functions";

class Category2 extends Component {
	constructor(props) {
		super(props);

		this.state = {
			category: [],
			ks: '',
			field: 'category',
			pkKey: 'category_id',
			category_id: [],
			isInit: false,
			action: 'category/' + this.props.type,
			selectTwoId: '',
			selectTwoCode: '',
			selectThreeId: '',
			selectThreeCode: '',
			categoryName: {},
			insertRecord: null,
			editIndex: '',
			type: '',
		}

		func.getData(this.state.action, null).then((response) => {
			let selectTwoId = getParams('selectTwoId') ? getParams('selectTwoId') : ''
			let selectTwoCode = ''
			let selectThreeId = getParams('selectThreeId') ? getParams('selectThreeId') : ''
			let selectThreeCode = ''
			let categoryName = {}
			// response.records = []
			response.records.map((item, i) => {
				if (selectTwoId === '') {
					if (item.up_category_id === 0 && selectTwoId === '') {
						selectTwoId = item.category_id;
						if(item.category_code)
							selectTwoCode = item.category_code;
					}
				}
				if (selectTwoId !== '' && selectThreeId === '' && selectTwoId === item.up_category_id) {
					selectThreeId = item.category_id
					if(item.category_code)
						selectThreeCode = item.category_code;
				}
				categoryName[item.category_id] = item.category_name
			});
			this.setState({
				isInit: true,
				categoryName: categoryName,
				selectTwoId: selectTwoId,
				selectTwoCode: selectTwoCode,
				selectThreeId: selectThreeId,
				selectThreeCode: selectThreeCode,
				category: response.records
			})
		});

		this.onInsert = this.onInsert.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onRemove = this.onRemove.bind(this);

		this.searchKs = this.searchKs.bind(this);
		this.setSelectID = this.setSelectID.bind(this);
		this.onEditIndex = this.onEditIndex.bind(this);
		this.showMessage = this.showMessage.bind(this);
	}

	onUpdate(index, item, render) {
		const category = this.state.category;
		category[index] = item;
		this.setState({category: category}, () => {
			if (render)
				this.forceUpdate()
		})
	}

	setSelectID(id, depth, code) {
		const activeTabID = getParams('tab_id') ? getParams('tab_id') : 0;
		if (depth === 1) {
			this.setState({
				selectTwoId: id,
				selectTwoCode: code ? code : '',
				selectThreeId: '',
				selectThreeCode: '',
			})
			pushUrl('코드', 'admin.php?page=researchmind-type&tab_id=' + activeTabID + '&selectTwoId=' + id, null);
		} else if (depth === 2) {
			this.setState({selectThreeId: id, selectThreeCode : code ? code : ''})
			pushUrl('코드', 'admin.php?page=researchmind-type&tab_id=' + activeTabID + '&selectTwoId=' +
				this.state.selectTwoId + '&selectThreeId=' + id, null);
		}
	}

	covertData(category) {
		const t = {};
		t.category = [];

		category = func.deepClone(category)

		let temp = [];
		let parentKey = {}
		let tt = {};
		category.map((item, i) => {
			item.index = i
			if ((item.depth_level === 1 || item.depth_level === 0) && item.up_category_id === 0) {
				item.children = {};
				tt[item.category_id] = item;
			} else if (item.depth_level === 2 && item.up_category_id) {
				if (tt[item.up_category_id]) {
					item.children = {};
					tt[item.up_category_id].children[item.category_id] = item
					parentKey[item.category_id] = item.up_category_id;
				} else {
					temp.push(item)
				}
			} else if (item.depth_level === 3 && item.up_category_id) {
				if (parentKey[item.up_category_id]) {
					tt[parentKey[item.up_category_id]].children[item.up_category_id].children[item.category_id] = item
				} else {
					temp.push(item)
				}
			}
		});
		temp.map((item, i) => {
			if (item.depth_level === 2 && item.up_category_id) {
				if (tt[item.up_category_id]) {
					item.children = {};
					tt[item.up_category_id].children[item.category_id] = item
					parentKey[item.category_id] = item.up_category_id;
				}
			} else if (item.depth_level === 3 && item.up_category_id) {
				if (parentKey[item.up_category_id]) {
					tt[parentKey[item.up_category_id]].children[item.up_category_id].children[item.category_id] = item
				}
			}
		});
		return tt
	}

	searchKs() {
		this.setState({ks: event.target.value})
		func.getData(this.state.action, {ks: event.target.value}).then((response) => {
			this.setState({category: response.records})
		});
	}

	onEditIndex(id) {
		if (this.state.editIndex === id)
			return;
		if (this.state.editIndex && this.refs["ref" + this.state.editIndex])
			this.refs["ref" + this.state.editIndex].onClose();
		else if (this.refs.ref)
			this.refs.ref.onClose();
		else if (this.refs["ref" + this.state.editIndex])
			this.refs["ref" + this.state.editIndex].onClose();

		this.setState({
			'editIndex': id
		})
	}

	onInsert(depth) {
		const category = this.state.category;

		if (depth === 1) {
			if (category.length > 0 && category[0][this.state.pkKey] === 0) {
				this.showMessage('추가해주세요.')
			} else {
				const insertRecord = {
					"category_id": 0,
					"up_category_id": 0,
					"category_name": "",
					"visible_seq": "1",
					"category_code": "",
					"category_type": this.props.type,
					"depth_level": 1,
					"disp_yn": "Y",
					"del_yn": "N",
					"is_edit": EDIT_MODE.SHOW_EDIT,
				};
				if(this.props.type === 'dept') {
					insertRecord.up_category_code = '0';
					insertRecord.homepage = '';
					insertRecord.address = '';
					insertRecord.tel = '';
					insertRecord.gps = '';
					insertRecord.thumbnail = '';
					insertRecord.head_name = '';
				}
				this.onEditIndex(0);
				category.unshift(insertRecord);
				this.setState({category: category}, () => {
					this.forceUpdate()
				})
			}
		} else if (depth === 2) {
			if (category.length > 0 && category[0][this.state.pkKey] === 0) {
				this.showMessage('추가해주세요.')
			} else {
				const insertRecord = {
					"category_id": 0,
					"up_category_id": this.state.selectTwoId,
					"up_category_code" : this.state.selectTwoCode,
					"category_name": "",
					"visible_seq": "1",
					"category_code": "",
					"category_type": this.props.type,
					"depth_level": 2,
					"disp_yn": "Y",
					"del_yn": "N",
					"is_edit": EDIT_MODE.SHOW_EDIT,
				};
				if(this.props.type === 'dept') {
					insertRecord.homepage = '';
					insertRecord.address = '';
					insertRecord.tel = '';
					insertRecord.gps = '';
					insertRecord.thumbnail = '';
					insertRecord.head_name = '';
				}
				this.onEditIndex(0);
				category.unshift(insertRecord);
				this.setState({category: category}, () => {
					this.forceUpdate()
				})
			}
		} else if (depth === 3) {
			if (category.length > 0 && category[0][this.state.pkKey] === 0) {
				this.showMessage('추가해주세요.')
			} else {
				const insertRecord = {
					"category_id": 0,
					"up_category_id": this.state.selectThreeId,
					"up_category_code" : this.state.selectTwoCode,
					"category_name": "",
					"visible_seq": "1",
					"category_code": "",
					"category_type": this.props.type,
					"depth_level": 3,
					"disp_yn": "Y",
					"del_yn": "N",
					"is_edit": EDIT_MODE.SHOW_EDIT,
				};
				if(this.props.type === 'dept') {
					insertRecord.homepage = '';
					insertRecord.address = '';
					insertRecord.tel = '';
					insertRecord.gps = '';
					insertRecord.thumbnail = '';
					insertRecord.head_name = '';
				}
				this.onEditIndex(0);
				category.unshift(insertRecord);
				this.setState({category: category}, () => {
					this.forceUpdate()
				})
			}
		}
	}

	onRemove(index, depth) {
		const category = this.state.category;
		category.splice(index, 1);
		this.setState({category: category}, () => {
			this.forceUpdate()
		})
	}

	showMessage(message) {
		this.props.fDataActions.setFooter({
			'isNoticePopup': true,
			'noticeMessage': message
		})
		setTimeout(() => {
			this.props.fDataActions.setFooter({
				'isNoticePopup': false,
				'noticeMessage': ''
			})
		}, 3000);
	}

	render() {

		if (!this.state.isInit)
			return ''

		let c = this.state.category;
		let ks = this.state.ks;
		if (ks) {
			// let search = ks;
			// let search1 = Hangul.disassemble(search).join("");  // ㄺ=>ㄹㄱ
			//
			// c = c.filter(function (item) {
			// 	return item.category_name.includes(search) || item.diassembled.includes(search1);
			// })
		}

		const category = this.covertData(c)

		return (
			<>
				<div className="row mt-4 mb-2">
					<div className="d-flex justify-content-center mb-3">
						<div className="form-inline">
							<div className="form-group mr-1">
								<input
									type="text"
									className="form-control top-search" id="ks" name="ks" value={this.state.ks}
									onChange={this.searchKs}/>
							</div>
							<button type="button" className="btn btn-primary btn-sm">Search</button>
						</div>
					</div>
				</div>

				<div className="row mt-4 mb-2">
					<div className="col-md-4">
						<h6>{this.props.title} 카테고리</h6>
						<div className="p-0">
							<div className="d-flex justify-content-end mb-1">
								<button type="button" className="btn btn-sm btn-primary" onClick={() => this.onInsert(1)}>추가</button>
							</div>
							<div className="card mt-0 p-0 scrollY600x">
								<table className="table table-thin border-bottom mb-0">
									<colgroup>
										<col width="20%"/>
										<col width=""/>
										{this.props.displayYN &&
										<col width="24px"/>
										}
										<col width="100px"/>
									</colgroup>
									<thead>
									<tr>
										<th scope="col">코드</th>
										<th scope="col">이름</th>
										{this.props.displayYN &&
										<th scope="col" style={{padding:"0px"}}>출력</th>
										}
										<th scope="col">액션</th>
									</tr>
									</thead>
									<tbody>
									{Object.keys(category).length <= 0 ?
										<tr>
											<td colSpan={3}>카테고리를 추가해주세요.</td>
										</tr>
										:
										Object.keys(category).map((key, index) => {
											const record = category[key]
											return (
												<CategoryItem
													key={record[this.state.pkKey]}
													index={record[this.state.pkKey]}
													ref={"ref" + record[this.state.pkKey]}
													arrIndex={index}
													record={record}
													pkKey={this.state.pkKey}
													depth={1}
													type={this.props.type}
													onUpdate={this.onUpdate}
													onRemove={this.onRemove}
													onEditIndex={this.onEditIndex}
													showMessage={this.showMessage}
													setSelectID={this.setSelectID}
													activeId={this.state.selectTwoId}
													displayYN={this.props.displayYN}
												/>
											)
										})}
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div className="col-md-4">
						<h6>{this.state.categoryName[this.state.selectTwoId] ? this.state.categoryName[this.state.selectTwoId] : '상위 카테고리를 선택해주세요.'}</h6>
						<div className="p-0">
							<div className="d-flex justify-content-end mb-1" style={{height: "31px"}}>
								{this.state.selectTwoId &&
								<button type="button" className="btn btn-sm btn-primary" onClick={() => this.onInsert(2)}>추가</button>
								}
							</div>
							<div className="card mt-0 p-0 scrollY600x">
								<table className="table table-thin border-bottom mb-0">
									<colgroup>
										<col width="20%"/>
										<col width=""/>
										{this.props.displayYN &&
										<col width="24px"/>
										}
										<col width="100px"/>
									</colgroup>
									<thead>
									<tr>
										<th scope="col">코드</th>
										<th scope="col">이름</th>
										{this.props.displayYN &&
										<th scope="col" style={{padding:"0px"}}>출력</th>
										}
										<th scope="col">액션</th>
									</tr>
									</thead>
									<tbody>
									{category[this.state.selectTwoId] && this.state.selectTwoId ?
										Object.keys(category[this.state.selectTwoId].children).length <= 0 ?
											<tr>
												<td colSpan={3}>하위 카테고리가 없습니다.</td>
											</tr>
											:
											Object.keys(category[this.state.selectTwoId].children).map((key, index) => {
												const record = category[this.state.selectTwoId].children[key]
												return (
													<CategoryItem
														key={record[this.state.pkKey]}
														index={record[this.state.pkKey]}
														ref={"ref" + record[this.state.pkKey]}
														arrIndex={index}
														record={record}
														pkKey={this.state.pkKey}
														depth={2}
														type={this.props.type}
														onUpdate={this.onUpdate}
														onRemove={this.onRemove}
														onEditIndex={this.onEditIndex}
														showMessage={this.showMessage}
														setSelectID={this.setSelectID}
														activeId={this.state.selectThreeId}
														displayYN={this.props.displayYN}
													/>
												)
											}) : <tr>
											<td colSpan={3}>상위 카테고리를 선택해주세요.</td>
										</tr>}
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<div className="col-md-4">
						<h6>{this.state.categoryName[this.state.selectThreeId] ? this.state.categoryName[this.state.selectThreeId] : '상위 카테고리를 선택해주세요.'}</h6>
						<div className="p-0">
							<div className="d-flex justify-content-end mb-1" style={{height: "31px"}}>
								{(this.state.selectTwoId && this.state.selectThreeId) &&
								<button type="button" className="btn btn-sm btn-primary" onClick={() => this.onInsert(3)}>추가</button>
								}
							</div>
							<div className="card mt-0 p-0 scrollY600x">
								<table className="table table-thin border-bottom mb-0">
									<colgroup>
										<col width="20%"/>
										<col width=""/>
										{this.props.displayYN &&
										<col width="24px"/>
										}
										<col width="100px"/>
									</colgroup>
									<thead>
									<tr>
										<th scope="col">코드</th>
										<th scope="col">이름</th>
										{this.props.displayYN &&
										<th scope="col" style={{padding:"0px"}}>출력</th>
										}
										<th scope="col">액션</th>
									</tr>
									</thead>
									<tbody>
									{(this.state.selectTwoId && this.state.selectThreeId && category[this.state.selectTwoId].children) ?
										Object.keys(category[this.state.selectTwoId].children[this.state.selectThreeId].children).length <= 0 ?
											<tr>
												<td colSpan={3}>하위 카테고리가 없습니다.</td>
											</tr>
											:
											Object.keys(category[this.state.selectTwoId].children[this.state.selectThreeId].children).map((key, index) => {
												const record = category[this.state.selectTwoId].children[this.state.selectThreeId].children[key]
												return (
													<CategoryItem
														key={record[this.state.pkKey]}
														index={record[this.state.pkKey]}
														ref={"ref" + record[this.state.pkKey]}
														arrIndex={index}
														record={record}
														pkKey={this.state.pkKey}
														depth={3}
														type={this.props.type}
														onUpdate={this.onUpdate}
														onRemove={this.onRemove}
														onEditIndex={this.onEditIndex}
														showMessage={this.showMessage}
														setSelectID={this.setSelectID}
														displayYN={this.props.displayYN}
													/>
												)
											}) : <tr>
											<td colSpan={3}>상위 카테고리를 선택해주세요.</td>
										</tr>}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</>
		)
	}
}

export default connect(
	(state) => ({}),
	(dispatch) => ({
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
)(Category2)

